import { AxiosRequestConfig } from 'axios';
import { merge } from 'lodash';

import Client from './client';
import { Business } from './types';

type Response = {
  readonly result: 'SUCCESS' | 'FAIL';
  readonly status: number;
  readonly businesses: Business[];
};

export default (
  offset: number = 0,
  limit: number = 20,
  config?: AxiosRequestConfig
) => {
  return Client.get<Response>(
    '/b/v1/businesses/of/labels',
    merge(config, {
      params: {
        labels: 31,
        offset,
        limit,
      },
    })
  );
};
